import * as React from "react";

import * as dates from "../../../reducers/changeTimePeriod";

import { IEvent } from "../../../classes/event";

export interface IEventTooltip {
    allDayText: string;
    event: IEvent;
    useSingleDayDescription?: boolean;
    theDate?: Date;
}

export const EventTooltip = (props: IEventTooltip) => {

    const event = props.event;
    const allDayText = props.allDayText;
    const theDate = props.theDate;

    let description = "";
    if (props.useSingleDayDescription) {
        description = dates.eventDescription_DailyList(event, allDayText, theDate);
    } else {
        description = dates.eventDescription(event, allDayText);
    }

    return (
        <div className="CAL-V-toolTip">
            <ul>
                <li>
                    <strong>
                        {event.icon &&
                            <img src={event.icon} aria-hidden="true" />
                        }
                        {event.name}
                    </strong>
                </li>

                <li><em className="fa fa-calendar" aria-hidden="true"></em> {description}</li>

                {event.location &&
                    <li><em className="fa fa-map-pin" aria-hidden="true"></em> {event.location}</li>
                }
                {event.category &&
                    <li><em className="fa fa-tag" aria-hidden="true"></em> {event.category}</li>
                }
            </ul>
            <div className="CAL-V-TT-triangle"></div>
        </div>
    );
};
